"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToCartContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.AddToCartContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  padding: ${props => props.theme.spacing.s4}px 0;

  > div {
    margin: 0;
  }
`;
exports.default = {
    AddToCartContainer: exports.AddToCartContainer
};
